
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.62 18.12c1.02-.78 2.16-1.395 3.42-1.845 1.26-.45 2.58-.675 3.96-.675s2.7.225 3.96.675c1.26.45 2.4 1.065 3.42 1.845.7-.82 1.245-1.75 1.635-2.79.39-1.04.585-2.15.585-3.33 0-2.66-.935-4.925-2.805-6.795S14.66 2.4 12 2.4s-4.925.935-6.795 2.805S2.4 9.34 2.4 12c0 1.18.195 2.29.585 3.33.39 1.04.935 1.97 1.635 2.79zM12 13.2c-1.18 0-2.175-.405-2.985-1.215S7.8 10.18 7.8 9s.405-2.175 1.215-2.985S10.82 4.8 12 4.8s2.175.405 2.985 1.215S16.2 7.82 16.2 9s-.405 2.175-1.215 2.985S13.18 13.2 12 13.2zM12 24c-1.66 0-3.22-.315-4.68-.945a12.118 12.118 0 01-3.81-2.565 12.118 12.118 0 01-2.565-3.81C.315 15.22 0 13.66 0 12c0-1.66.315-3.22.945-4.68.63-1.46 1.485-2.73 2.565-3.81A12.118 12.118 0 017.32.945C8.78.315 10.34 0 12 0c1.66 0 3.22.315 4.68.945 1.46.63 2.73 1.485 3.81 2.565a12.118 12.118 0 012.565 3.81c.63 1.46.945 3.02.945 4.68 0 1.66-.315 3.22-.945 4.68a12.118 12.118 0 01-2.565 3.81 12.118 12.118 0 01-3.81 2.565c-1.46.63-3.02.945-4.68.945zm0-2.4c1.06 0 2.06-.155 3-.465.94-.31 1.8-.755 2.58-1.335A9.036 9.036 0 0015 18.465 9.519 9.519 0 0012 18c-1.06 0-2.06.155-3 .465-.94.31-1.8.755-2.58 1.335.78.58 1.64 1.025 2.58 1.335.94.31 1.94.465 3 .465zm0-10.8c.52 0 .95-.17 1.29-.51.34-.34.51-.77.51-1.29s-.17-.95-.51-1.29c-.34-.34-.77-.51-1.29-.51s-.95.17-1.29.51c-.34.34-.51.77-.51 1.29s.17.95.51 1.29c.34.34.77.51 1.29.51z","fill":"#fff"}})])
          )
        }
      }
    